import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_GREEN, BRAND_GOLD } from '../theme/sucronTheme';


export default function PrivacyPolicyPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
          Política de Privacidade
        </h1>
        <p className="text-sm text-gray-500">
          Última atualização: 29 de maio de 2026
        </p>
      </div>

      {/* Conteúdo */}
      <div className="space-y-6 text-gray-700">
        {/* 1. SOBRE A ARENA STATS */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            1. SOBRE A VUKZ AI
          </h2>
          <p className="leading-relaxed">
            Nós somos a VUKZ AI (razão social Arena Stats), inscrita no CNPJ sob o n° 61.698.906/0001-16, com sede na Avenida Presidente Antônio Carlos, n° 681, bairro Lagoinha, Belo Horizonte/MG, CEP 31210-010.
            Somos uma empresa que desenvolve e opera a plataforma VUKZ — um Performance OS para esportes — oferecida como Software como Serviço (SaaS) B2B para clubes, federações, atletas e staff esportivo.
            Nosso contato para quaisquer dúvidas, solicitações ou comunicações relacionadas a esta Política de Privacidade, poderá por meio do e-mail privacidade@vukz.ai ou acessar o site www.vukz.ai.
            Este Aviso de Privacidade entra em vigor em 29 de maio de 2026 e aplica-se aos tratamentos descritos no site https://www.vukz.ai e na plataforma https://app.vukz.ai e canais indicados.
          </p>
        </section>

        {/* 2. COMPROMISSO */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            2. COMPROMISSO
          </h2>
          <p className="leading-relaxed mb-3">
            A VUKZ AI valoriza a sua privacidade e está comprometida com a transparência, ética e respeito à privacidade de seus clientes, parceiros e visitantes.
          </p>
          <p className="leading-relaxed mb-3">
            Adotamos todas as medidas cabíveis para assegurar a proteção de seus dados pessoais, em conformidade com as normas legais vigentes sobre privacidade e proteção de dados, especialmente a Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais – LGPD).
          </p>
          <p className="leading-relaxed mb-3">
            Este Aviso de Privacidade tem o objetivo de explicar como coletamos, usamos, armazenamos e protegemos os dados pessoais de quem acessa nosso site, redes sociais, canais de venda e demais meios de contato, e, sobretudo, quais são os seus direitos enquanto titular dos dados e como podem ser exercidos.
          </p>
          <p className="leading-relaxed">
            Caso haja qualquer dúvida quanto aos termos empregados neste Aviso, recomendamos a consulta ao item "Definições", no item 4 deste documento.
            <strong>Solicitamos que leia atentamente este Aviso de Privacidade!</strong>
          </p>
        </section>

        {/* 3. A QUEM SE APLICA? */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            3. A QUEM SE APLICA?
          </h2>
          <p className="leading-relaxed">
            O aviso aplica-se a visitantes do site, usuários cadastrados, potenciais clientes, representantes de clientes/fornecedores e demais pessoas que interajam com nossos canais.
          </p>
        </section>

        {/* 4. DEFINIÇÕES */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            4. DEFINIÇÕES
          </h2>
          <p className="leading-relaxed mb-3">
            Para facilitar a sua compreensão sobre esse Aviso de Privacidade seguem, abaixo, algumas definições relevantes de termos e expressões que você encontrará daqui em diante:
          </p>
          <div className="space-y-2">
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Agentes de tratamento:</strong></div>
              <div>Controlador e Operador, conforme o art. 5º, VI e VII, da LGPD.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Anonimização:</strong></div>
              <div>Utilização de meios técnicos razoáveis e disponíveis no momento do tratamento, por meio dos quais um dado perde a possibilidade de associação, direta ou indireta, a um indivíduo.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Autoridade Nacional (ANPD):</strong></div>
              <div>Órgão da administração pública responsável por zelar, implementar e fiscalizar o cumprimento da Lei Geral de Proteção de Dados -LGPD em todo o território nacional.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Banco de Dados:</strong></div>
              <div>Conjunto estruturado de dados pessoais, estabelecido em um ou em vários locais, em suporte eletrônico ou físico.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Consentimento:</strong></div>
              <div>Manifestação livre, informada e inequívoca pela qual o titular concorda com o tratamento de seus dados pessoais para uma finalidade determinada.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Controlador:</strong></div>
              <div>Pessoa natural ou jurídica, de direito público ou privado, a quem competem as decisões referentes ao tratamento de dados pessoais.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Dado Anonimizado:</strong></div>
              <div>Dado relativo a um titular que não possa ser identificado, considerando a utilização de meios técnicos razoáveis e disponíveis na ocasião de seu tratamento.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Dado Pessoal:</strong></div>
              <div>Informação relacionada a uma pessoa natural identificada ou identificável.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Dado Pessoal Sensível:</strong></div>
              <div>Dado sobre origem racial/étnica, convicção religiosa, opinião política, saúde, vida sexual, dado genético/biométrico etc.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Eliminação:</strong></div>
              <div>Exclusão de dado ou de conjunto de dados armazenados em banco de dados, independentemente do procedimento empregado;</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Encarregado:</strong></div>
              <div>Pessoa indicada pelo controlador e operador para atuar como canal de comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD).</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Legítimo Interesse:</strong></div>
              <div>Base legal aplicável quando o tratamento for necessário para atender interesses legítimos do controlador ou de terceiro, observados finalidade, necessidade e balanceamento.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Usuário:</strong></div>
              <div>Pessoa natural a quem se referem os dados pessoais que são objeto de tratamento.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Tratamento:</strong></div>
              <div>Toda operação realizada com dados pessoais, como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.</div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div><strong>Transferência Internacional:</strong></div>
              <div>Transferência de dados pessoais para país estrangeiro ou organismo internacional do qual o país seja membro;</div>
            </div>
          </div>
        </section>

        {/* 5. TRATAMENTO DE DADOS PESSOAIS */}
        <section className="bg-green-50 rounded-xl border-2 p-6" style={{ borderColor: BRAND_GREEN }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            5. TRATAMENTO DE DADOS PESSOAIS
          </h2>
          <p className="leading-relaxed mb-4">
            A coleta de dados pessoais pode ocorrer mediante seu fornecimento voluntário, de forma automatizada ou a partir de informações tornadas publicamente acessíveis.
          </p>

          <h3 className="text-lg font-semibold mb-3" style={{ color: BRAND_GOLD }}>
            5.1. Dados coletados
          </h3>
          <p className="mb-3">A VUKZ AI poderá coletar os seguintes dados pessoais dos usuários:</p>

          <h4 className="font-semibold mb-2" style={{ color: BRAND_GREEN }}>• Dados fornecidos voluntariamente pelo usuário:</h4>
          <p className="mb-3">Formulários de cadastro e acesso: nome, e-mail, cargo e informações da organização (clube/federação), coletados para criação de conta e prestação do serviço SaaS contratado.</p>
          <p className="mb-3">Dados de performance esportiva: resultados de treinos, métricas físicas, vídeos de análise biomecânica e demais dados inseridos pelo usuário ou importados via integrações autorizadas, para fins exclusivos de funcionamento do serviço Performance OS.</p>
          <p className="mb-4">Dados de faturamento: informações necessárias para gestão da assinatura e emissão de faturas (razão social, CNPJ, endereço), tratados com base em execução de contrato.</p>

          <h4 className="font-semibold mb-2" style={{ color: BRAND_GREEN }}>• Dados coletados automaticamente:</h4>
          <p className="mb-3">A plataforma também poderá coletar, de forma automatizada, informações sobre a navegação do usuário, incluindo:</p>
          <ul className="space-y-1 mb-4 ml-6">
            <li>Cookies de sessão, endereço IP, tipo de dispositivo e navegador. Essas informações são utilizadas exclusivamente para métricas de desempenho, análise estatística e segurança da plataforma.</li>
          </ul>
          <p className="mb-4">Para essa coleta, a VUKZ AI faz uso de cookies e tecnologias similares, que auxiliam na compreensão de como o usuário interage com o site e quais recursos são mais utilizados, com o objetivo de aprimorar continuamente os serviços e funcionalidades oferecidos.</p>

          <h4 className="font-semibold mb-2" style={{ color: BRAND_GREEN }}>• Dados disponíveis publicamente:</h4>
          <p className="mb-3">Em determinadas situações, poderão ser utilizados dados tornados publicamente acessíveis, respeitando os princípios da finalidade, necessidade e transparência.</p>

          <h3 className="text-lg font-semibold mb-3" style={{ color: BRAND_GOLD }}>
            5.2. Para quais finalidades os dados pessoais são processados?
          </h3>
          <p className="mb-3">A VUKZ AI realiza o tratamento dos dados pessoais para as seguintes finalidades:</p>
          <ul className="space-y-2 mb-4 ml-4">
            <li>• Prestação dos serviços SaaS contratados (Performance OS, treinamento, analytics, agentes de IA).</li>
            <li>• Gerar relatórios e análises de performance para uso exclusivo do cliente contratante.</li>
            <li>• Aprimorar os recursos e funcionalidades da plataforma, com base na análise de preferências e interações dos usuários.</li>
            <li>• Assegurar a segurança digital e o bom funcionamento do sistema, prevenindo fraudes e acessos indevidos.</li>
            <li>• Gestão da relação contratual (faturamento, suporte, renovação de assinatura).</li>
            <li>• Cumprimento de obrigações legais e regulatórias aplicáveis.</li>
          </ul>
          <p className="mb-3">Os relatórios e análises produzidos são exclusivos de cada organização contratante e não são compartilhados com outros clientes.</p>
          <p className="mb-3">A VUKZ AI não utiliza os dados de performance dos atletas para fins de publicidade direcionada ou venda a terceiros.</p>

          <h3 className="text-lg font-semibold mb-3" style={{ color: BRAND_GOLD }}>
            5.3. Quem é o responsável pelo tratamento dos dados
          </h3>
          <p className="mb-3">A VUKZ AI atua como controladora dos dados pessoais, sendo responsável pelas decisões relacionadas ao tratamento dessas informações no contexto da relação mantida com o usuário.</p>
          <p className="mb-3">Em contratos SaaS B2B com organizações clientes (clubes, federações), a VUKZ AI pode atuar como operadora de dados pessoais dos membros da organização, seguindo as orientações do cliente responsável pelo tratamento (controlador). Nesses casos, o uso dos dados ocorre conforme contrato de serviço específico firmado entre as partes (DPA — Data Processing Agreement).</p>

          <h3 className="text-lg font-semibold mb-3" style={{ color: BRAND_GOLD }}>
            5.4. Uso por menores de idade
          </h3>
          <p className="leading-relaxed">
            Os serviços e conteúdos disponibilizados pela VUKZ AI podem ser direcionados a menores de 18 (dezoito) anos. Caso ocorra a coleta eventual de dados pessoais de menores, esta será realizada somente mediante consentimento específico e em destaque dado por, pelo menos, um dos pais ou responsável legal, conforme dispõe o art. 14 da Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais – LGPD).
          </p>
        </section>

        {/* 6. BASE LEGAIS PARA TRATAMENTO DE DADOS */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            6. BASE LEGAIS PARA TRATAMENTO DE DADOS
          </h2>
          <p className="leading-relaxed">
            A VUKZ AI coleta e trata dados pessoais quando possui uma base legal que devidamente respalde a atividade de tratamento.
            Utilizamos diferentes bases legais, a depender da finalidade: execução de contrato, cumprimento de obrigação legal (p. ex., logs de acesso – Marco Civil), legítimo interesse (segurança, melhoria de serviços, métricas essenciais, prevenção a fraudes), e consentimento (p. ex., cookies não essenciais e comunicações promocionais).
          </p>
        </section>

        {/* 7. TEMPO DE ARMAZENAMENTO DE DADOS */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            7. TEMPO DE ARMAZENAMENTO DE DADOS
          </h2>
          <p className="leading-relaxed mb-3">
            A VUKZ AI armazenará e tratará seus dados pessoais enquanto forem necessários para atingir as finalidades para as quais foram coletados, ou até que deixem de ser pertinentes ao objetivo específico do tratamento.
          </p>
          <ul className="space-y-1 mb-3 ml-4">
            <li>• Dados de navegação: armazenados por até 12 meses;</li>
            <li>• Dados de contato e preferências esportivas: armazenados por até 24 meses, ou até que o usuário solicite sua exclusão.</li>
          </ul>
          <p className="leading-relaxed">
            Todos os dados são mantidos de forma segura, seguindo boas práticas de proteção de informações. Em casos específicos, alguns dados poderão ser retidos mesmo após o término da finalidade original, para auditoria, cumprimento de obrigações legais ou regulatórias, ou para assegurar o exercício regular de direitos.
          </p>
        </section>

        {/* 8. SEUS DIREITOS COMO TITULAR */}
        <section className="bg-green-50 rounded-xl border-2 p-6" style={{ borderColor: BRAND_GREEN }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            8. SEUS DIREITOS COMO TITULAR
          </h2>
          <p className="leading-relaxed mb-3">
            Sempre que a VUKZ AI atuar como controladora dos dados pessoais, empregaremos todos os esforços para garantir o exercício dos seus direitos. Você, como titular dos dados pessoais sobre os quais tratamos nesta Política, tem direito a obter:
          </p>
          <ul className="space-y-2 mb-4 ml-4">
            <li>• Confirmação da existência de tratamento;</li>
            <li>• Acesso aos dados;</li>
            <li>• Cópia de todos os seus dados pessoais sob a posse da Arena;</li>
            <li>• Correção de dados incompletos, inexatos ou desatualizados;</li>
            <li>• Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na LGPD;</li>
            <li>• Eliminação dos dados pessoais tratados com o seu consentimento;</li>
            <li>• Informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;</li>
            <li>• Revogação do consentimento, nos termos do art. 8º, § 5º, da LGPD;</li>
            <li>• Revisão de decisões automatizadas – isto é, tomadas unicamente com base em tratamento automatizado de dados pessoais – que o afetem.</li>
          </ul>
          <p className="leading-relaxed mb-3">
            Importante ressaltar que a solicitação de interrupção do uso de todos ou de alguns de seus Dados Pessoais, ou a limitação de sua utilização pela Arena, poderá prejudicar o alcance da finalidade que justificou a coleta dos Dados e a comunicação da Arena com você.
          </p>
          <p className="leading-relaxed mb-3">
            A revogação do consentimento não impedirá a Arena de tratar seus Dados, podendo o tratamento ocorrer em relação a outros Dados que não sejam pessoais ou quando houver outras bases legais para o tratamento, dispostas na legislação de proteção de Dados Pessoais.
          </p>
          <p className="leading-relaxed">
            Caso você queira exercer quaisquer dos seus direitos, poderá entrar em contato conosco por meio do e-mail privacidade@vukz.ai, que será o canal oficial para comunicações sobre dados pessoais.
          </p>
        </section>

        {/* 9. SERVIDORES */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            9. SERVIDORES
          </h2>
          <p className="leading-relaxed mb-3">
            A utilização da plataforma VUKZ depende da criação de uma Conta de Acesso, com o registro de alguns dados e informações pessoais, conforme definidos neste documento. Os dados solicitados para realização deste cadastro servem apenas para gestão, navegação e consulta da própria plataforma, tanto por nós quanto por você.
          </p>
          <p className="leading-relaxed mb-3">
            Preocupados com a segurança da informação, todo o armazenamento de dados é realizado em ambiente seguro na Microsoft Azure (região Brazil South), que possui protocolos avançados de proteção e ferramentas de segurança de alto nível.
          </p>
          <p className="leading-relaxed mb-3">
            É importante que você mantenha os dados da sua Conta de Acesso (login e senha) sob total sigilo, não os divulgando a terceiros.
          </p>
          <p className="leading-relaxed mb-3">
            A Arena nunca solicitará ao titular que informe sua senha por telefone, e-mail ou qualquer outro meio externo à plataforma.
          </p>
          <p className="leading-relaxed mb-4">
            Caso você suspeite que sua senha tenha sido exposta a terceiros, comunique-nos imediatamente e altere sua senha.
          </p>

          <h3 className="text-lg font-semibold mb-3" style={{ color: BRAND_GOLD }}>
            9.1. Transferência internacional
          </h3>
          <p className="leading-relaxed mb-3">
            A empresa poderá transferir dados pessoais coletados para outras empresas do mesmo grupo econômico, parceiros comerciais ou prestadores de serviço localizados no Brasil ou no exterior, sempre que essa transferência for necessária para a execução de suas atividades, cumprimento de obrigações legais ou melhoria de seus serviços.
          </p>
          <p className="leading-relaxed mb-3">
            Os dados pessoais tratados no âmbito deste instrumento poderão ser armazenados e processados em servidores localizados na plataforma Microsoft Azure, especificamente na Região "Brazil South" (São Paulo). Contudo, poderá haver transferência internacional de dados para outras regiões onde a Microsoft mantém infraestrutura de processamento, incluindo o Centro-Sul dos Estados Unidos (South Central US), com a finalidade de garantir estabilidade, redundância e segurança operacional.
          </p>
          <p className="leading-relaxed">
            Nessas hipóteses, a empresa assegura que toda e qualquer transferência internacional de dados observará os requisitos previstos na Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD), garantindo que as entidades receptoras mantenham níveis adequados de proteção e segurança da informação, equivalentes aos exigidos pela legislação brasileira.
          </p>
        </section>

        {/* 10. MEDIDAS DE SEGURANÇA */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            10. MEDIDAS DE SEGURANÇA
          </h2>
          <p className="leading-relaxed mb-3">
            A Arena adota todas as medidas digitais de segurança compatíveis com sua atuação e porte, utilizando recursos tecnológicos avançados para garantir a proteção de todos os Dados coletados e armazenados.
          </p>
          <p className="leading-relaxed mb-3">
            Adotamos medidas técnicas e administrativas proporcionais ao risco, incluindo controle de acesso, registro de eventos, criptografia, segregação de ambientes, gestão de vulnerabilidades e políticas internas.
          </p>
          <p className="leading-relaxed mb-3">
            A Arena manterá em sua base de dados informações relativas aos acessos do titular à plataforma, mas não se limitando ao endereço IP, páginas acessadas, horários e datas de acesso, e o dispositivo utilizado.
          </p>
          <p className="leading-relaxed mb-3">
            Esses registros poderão ser utilizados em investigações internas ou públicas para averiguação de práticas que possam gerar quaisquer prejuízos à Arena, a outros titulares ou a terceiros, inclusive em casos de prática de crimes em ambientes virtuais.
          </p>
          <p className="leading-relaxed">
            Em caso de incidente de segurança que possa acarretar risco ou dano relevante aos titulares, a VUKZ AI realizará a gestão do incidente conforme suas políticas internas e procederá à notificação à Autoridade Nacional de Proteção de Dados (ANPD) e aos titulares afetados, quando aplicável, em conformidade com o art. 48 da Lei nº 13.709/2018 (LGPD) e as orientações emitidas pela ANPD.
          </p>
        </section>

        {/* 11. ENCARREGADO DE DADOS */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            11. ENCARREGADO DE DADOS
          </h2>
          <p className="leading-relaxed mb-3">
            O Encarregado de Dados (DPO) da Arena é Paulo Brandt. Caso você queira entrar em contato diretamente com ele para discutir qualquer disposição deste Aviso, bem como para solicitar o atendimento de quaisquer direitos relacionados ao tratamento de seus dados pessoais, basta enviar um e-mail para o endereço eletrônico privacidade@vukz.ai, incluindo, no assunto, o motivo do contato. Este será o canal oficial para comunicações sobre dados pessoais.
          </p>
        </section>

        {/* 12. ALTERAÇÃO DA POLÍTICA DE PRIVACIDADE */}
        <section className="bg-white rounded-xl border-2 p-6" style={{ borderColor: 'var(--brand-border)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: BRAND_GREEN }}>
            12. ALTERAÇÃO DA POLÍTICA DE PRIVACIDADE
          </h2>
          <p className="leading-relaxed mb-3">
            A VUKZ AI atualizará este Aviso de Privacidade sempre que ocorrerem modificações em seus processos de tratamento de dados ou quando houver alterações na legislação que justifiquem ajustes em seu conteúdo.
          </p>
          <p className="leading-relaxed mb-3">
            Este Aviso de Privacidade entra em vigor em 29 de maio de 2026.
          </p>
          <p className="leading-relaxed mb-3">
            Caso sejam realizadas alterações relevantes, especialmente aquelas que impliquem em nova finalidade de tratamento ou modifiquem de forma significativa os direitos dos titulares, os titulares serão informados por meio dos canais oficiais da VUKZ AI, como o site institucional (www.vukz.ai) ou outros meios de comunicação disponíveis.
          </p>
          <p className="leading-relaxed">
            Quando as mudanças exigirem, a VUKZ AI solicitará novo consentimento aos titulares antes de dar continuidade ao tratamento dos dados pessoais sob as novas condições.
          </p>
        </section>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t-2" style={{ borderColor: 'var(--brand-border)' }}>
          <p className="text-center text-sm text-gray-600">
            Ao utilizar a VUKZ, você concorda com esta Política de Privacidade.
            <br />
            Leia também nossos{' '}
            <Link to="/termos" className="font-semibold hover:underline" style={{ color: BRAND_GREEN }}>
              Termos de Uso
            </Link>
            {' '}e nosso{' '}
            <Link to="/sla" className="font-semibold hover:underline" style={{ color: BRAND_GREEN }}>
              Acordo de Nível de Serviço (SLA)
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
